import { call, put, select, takeLatest } from "redux-saga/effects";

import {
  FetchSettingsAction,
  setSettings,
  setSettingsError,
  setSettingsLoading,
  FETCH_SETTINGS,
} from "../actions/root.actions";
import { accountApi, Settings } from "../../api";
import { IRootStateType, IStateType } from "../models/root.interface";

const api = {
  getAccountSettings: (...args: Parameters<typeof accountApi.getAccountSettings>) =>
    accountApi.getAccountSettings(...args),
}

function* fetchSettings(action: FetchSettingsAction) {
  const state: IRootStateType = yield select((state: IStateType) => state.root);
  if (!state.settings || state.settings === "error") {
    // Denote loading
    yield put(setSettingsLoading());
    try {
      // Request
      const { data } = yield call(api.getAccountSettings);
      // Store data
      yield put(setSettings(data as Settings));
    } catch (e) {
      // Denote error
      yield put(setSettingsError());
    }
  }
}

function* rootSaga() {
  yield takeLatest(FETCH_SETTINGS, fetchSettings);
}

export default rootSaga;
